import { Component, Input, OnInit, inject } from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SharedModalControllerService} from '@shared/services/shared-modal-controller.service';
import {SafeUrl} from '@angular/platform-browser';
import {SharedSafePipe} from '@shared/pipes/shared-safe.pipe';
import {IViewerBlobSrc, IViewerUrlSrc} from '../interfaces/viewer-src.interface';
import {PinchZoomComponent} from "@meddv/ngx-pinch-zoom";

@Component({
  selector: 'app-viewer-image',
  templateUrl: './shared-viewer-image.component.html',
  styleUrls: ['./shared-viewer-image.component.scss'],
  imports: [IonicModule, PinchZoomComponent, SharedSafePipe],
  standalone: true,
})
export class SharedViewerImageComponent implements OnInit {
  private _modalCtrlService = inject(SharedModalControllerService);

  @Input() file!: IViewerBlobSrc | IViewerUrlSrc;
  @Input() name!: string;
  @Input() uri?: string;
  @Input() isDownloadEnabled?: boolean = false;

  image!: SafeUrl;

  ngOnInit() {
    this._transformBlobToImage();
  }

  /**
   * @name _transformBlobToImage
   * @description
   * Transform the blob to a valid url image
   * @memberof SharedViewerImageComponent
   * @private
   */
  private _transformBlobToImage(): void {
    if ((this.file as IViewerUrlSrc)?.url) {
      this.image = (this.file as IViewerUrlSrc).url;
    }
    if ((this.file as IViewerBlobSrc)?.file) {
      this.image = URL.createObjectURL((this.file as IViewerBlobSrc).file);
    }
  }

  /**
   * @name exit
   * @description
   * call modal controller service to close the modal
   * @memberof SharedViewerImageComponent
   */
  exit(): void {
    this._modalCtrlService.closeModal();
  }
}
